"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dexie_db_1 = __importDefault(require("./dexie-db"));
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var defaults_1 = __importDefault(require("../defaults"));
var errors_1 = require("../utils/errors");
var fetch_progress_1 = __importDefault(require("fetch-progress"));
/**
 * Provides access to the campaign previews
 *
 * In this class the token is mandatory
 * it can be obtained from a campaign item using {@link CampaignAccess}
 * @class
 *
 * @param {string} token | the api host
 * @param {string} [hosts = defaults] | the api host
 *
 * @category ClientDataLayers
 *
 * @example
 * // TEST METHOD FOR USING WITHIN A REACT COMPONENT
 * // in the render method call this one like:
 * // <button onClick={() => this.accessPreview()}>GET PREVIEW DATA</button>
 *
 *  accessPreview = async event => {
        const { previewToken } = this.state;
        const previewAccess = new PreviewAccess({ token: previewToken, host: 'http://localhost:4000/dev' })
        console.log(previewAccess)
        try {

            const campaign_data = await previewAccess.getCampaign()
            console.log("CAMPAIGN PREVIEW DATA", campaign_data);
        } catch (error) {
            // Handle the error in th ui.
            console.log("ERROR GETING PREVIEW DATA", error);

        }
    }
 *
 */
var PreviewAccess = /** @class */ (function () {
    /**
     *
     * @param {DataLayerConfiguration} options
     * @param {token} options.token An access token
     * @param {host} [options.host = defaults.host] An access token
     *
     */
    function PreviewAccess(_a) {
        var token = _a.token, _b = _a.hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this.token = token;
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
    }
    /**
     * Gets preview campaign data with a public access token
     *
     * @returns {Promise<CampaignData>} The preview campaign data fields
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    PreviewAccess.prototype.getCampaign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, json, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.getCampaignPreview()];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _a.sent();
                        if (res.status === 400) {
                            throw new errors_1.PermissionError(json.message);
                        }
                        return [2 /*return*/, json];
                    case 3:
                        error_1 = _a.sent();
                        throw new errors_1.PermissionError(error_1.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Gets an access URL to a filename included in a preview campaign
     * if exists
     *
     * @param {string} fileName The file name
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     *
     * @example
     *
     * const { fileName } = '{{campaignId}}-MyFile.mp4';
     * const { previewToken } = this.state;
     * const previewAccess = new PreviewAccess({ token: previewToken, host: 'http://localhost:4000/dev' })
     *   try {
     *       const {uri} = await previewAccess.getFile(fileName);
     *       // reload a video HTML tag element
     *       document.getElementById("video-tag").load();
     *   } catch (error) {
     *       console.log('ERROR',error)
     *   };
     *
     */
    PreviewAccess.prototype.getFile = function (fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var res, sas, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.getFilePreview(fileName)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        sas = _a.sent();
                        if (res.status === 400) {
                            throw new errors_1.PermissionError(sas.message);
                        }
                        return [2 /*return*/, sas];
                    case 3:
                        error_2 = _a.sent();
                        throw new errors_1.PermissionError(error_2.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage
     * it tries to retrieve the file from local or dowload and stores the assets.
     * either way returns a local blob url.
     *
     * @param fileName
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    PreviewAccess.prototype.getOfflineFile = function (fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var blob, blobFromDb, error_3, res, sas, res2, fileItem, error_4, error_5, blobURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(fileName).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.log('db error getOfflineFile 1', { error: error_3 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 16];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 14, , 15]);
                        return [4 /*yield*/, this.api.getFilePreview(fileName)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 13];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.uri)];
                    case 8:
                        res2 = _a.sent();
                        return [4 /*yield*/, res2.blob()];
                    case 9:
                        blob = _a.sent();
                        fileItem = {
                            id: fileName + '-preview',
                            fileName: fileName + '-preview',
                            storedAt: Date.now(),
                            blob: blob
                        };
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                    case 11:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        error_4 = _a.sent();
                        console.log('db error getOfflineFile 2', { error: error_4 });
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        error_5 = _a.sent();
                        throw new errors_1.PermissionError(error_5.message);
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        blob = blobFromDb[0].blob;
                        _a.label = 17;
                    case 17: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 18:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
 * Test method for preloading assets in the indexedDB local storage
 * it tries to retrieve the file from local or dowload and stores the assets.
 * either way returns a local blob url.
 *
 * @param {string} fileName
 * @param {function} progress A callback function with the progress
 *
 * @returns {Promise<SAS>}  Shared access credentials
 *
 * @throws {PermissionError} 403 responses or bad token
 */
    PreviewAccess.prototype.getOfflineFilmFile = function (getOfflineFilmFileRequest, progress) {
        return __awaiter(this, void 0, void 0, function () {
            var fileName, linkUrl, compressed, id, blob, blobFromDb, error_6, res, sas, error_7, blobURL;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileName = getOfflineFilmFileRequest.fileName, linkUrl = getOfflineFilmFileRequest.linkUrl, compressed = getOfflineFilmFileRequest.compressed;
                        id = linkUrl ? fileName + '-' + linkUrl : compressed ? fileName + '-compressed' : fileName;
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(id).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.log('getOfflineFilmFile db error 1', error_6);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 12];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 10, , 11]);
                        return [4 /*yield*/, this.api.getPreviewFilmFile(getOfflineFilmFileRequest)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas[0]).then(fetch_progress_1.default({
                                onProgress: function (e) {
                                    if (progress)
                                        progress(e);
                                },
                            })).then(function (res2) { return res2.blob(); }).then(function (blobResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var fileItem, error_8;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            blob = blobResponse;
                                            fileItem = {
                                                id: id,
                                                fileName: id,
                                                storedAt: Date.now(),
                                                blob: blob
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_8 = _a.sent();
                                            console.log('getOfflineFilmFile db error 2', error_8);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_7 = _a.sent();
                        console.log('getOfflineFilmFile error', { error: error_7 });
                        throw new errors_1.PermissionError(error_7.message);
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        blob = blobFromDb[0].blob;
                        _a.label = 13;
                    case 13: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 14:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    return PreviewAccess;
}());
;
exports.default = PreviewAccess;
//# sourceMappingURL=PreviewAccess.js.map